<app-hero [title]="'Mein Profil'"></app-hero>

<div class="container mt-5">
  <div class="row">
    <div class="col-md-12">
      <!-- Nav pills -->
      <ul class="nav nav-pills mb-3" id="accountTabs" role="tablist">
        <li class="nav-item m-1" role="presentation">
          <a
            class="nav-link"
            [class.active]="activeTab === 'account'"
            (click)="setActiveTab('account')"
            id="account-tab"
            data-bs-toggle="pill"
            href="#account"
            role="tab"
            aria-controls="account"
            [attr.aria-selected]="activeTab === 'account' ? 'true' : 'false'"
          >
            <i class="bx bx-user me-1"></i> Konto
          </a>
        </li>
        <li class="nav-item m-1" role="presentation">
          <a
            class="nav-link"
            [class.active]="activeTab === 'notifications'"
            (click)="setActiveTab('notifications')"
            id="notifications-tab"
            data-bs-toggle="pill"
            href="#notifications"
            role="tab"
            aria-controls="notifications"
            [attr.aria-selected]="activeTab === 'notifications' ? 'true' : 'false'"
          >
            <i class="bx bx-bell me-1"></i> Benachrichtigungen
          </a>
        </li>
        <li class="nav-item m-1" role="presentation">
          <a
            class="nav-link"
            [class.active]="activeTab === 'applications'"
            (click)="setActiveTab('applications'); getApplication()"
            id="applications-tab"
            data-bs-toggle="pill"
            href="#applications"
            role="tab"
            aria-controls="applications"
            [attr.aria-selected]="activeTab === 'applications' ? 'true' : 'false'"
          >
            <i class="bx bx-link-alt me-1"></i> Meine Bewerbungen
          </a>
        </li>
      </ul>

      <!-- Tab content -->
      <div class="tab-content" id="accountTabsContent">
        <!-- Account Tab -->
        <div
          class="tab-pane fade"
          [class.show]="activeTab === 'account'"
          [class.active]="activeTab === 'account'"
          id="account"
          role="tabpanel"
          aria-labelledby="account-tab"
        >
          <div class="card mb-4">
            <h5 class="card-header">Profildetails</h5>
            <div class="card-body">
              <div class="d-flex align-items-start align-items-sm-center gap-4">
                <img
                  [src]="tempImageUrl || userInfo.image || '../assets/img/avatars/1.png'"
                  alt="Benutzer-Avatar"
                  class="d-block rounded"
                  height="100"
                  width="100"
                  id="uploadedAvatar"
                />
                <div class="button-wrapper">
                  <label for="upload" class="btn btn-primary me-2 mb-4" tabindex="0">
                    <span class="d-none d-sm-block">Neues Foto hochladen</span>
                    <i class="fa fa-upload d-block d-sm-none"></i>
                    <input
                      type="file"
                      id="upload"
                      class="account-file-input"
                      hidden
                      accept="image/png, image/jpeg"
                      (change)="onFileSelected($event)"
                    />
                  </label>
                  <button type="button" class="btn btn-outline-secondary account-image-reset mb-4" (click)="onResetImage()">
                    <i class="fa fa-refresh d-block d-sm-none"></i>
                    <span class="d-none d-sm-block">Zurücksetzen</span>
                  </button>
                  <p class="text-muted mb-0">Erlaubt sind JPG, GIF oder PNG. Maximale Größe: 800 KB</p>
                </div>
              </div>
            </div>
            <hr class="my-0" />
            <div class="card-body">
              <form #formAccountSettings="ngForm" (ngSubmit)="onUpdate(formAccountSettings)" novalidate>
                <div class="row">
                  <div class="mb-3 col-md-6">
                    <label for="fullName" class="form-label">Vollständiger Name</label>
                    <input class="form-control" type="text" name="fullName" id="fullName" [(ngModel)]="userInfo.fullName" required />
                    <div *ngIf="formAccountSettings.controls['fullName']?.invalid && (formAccountSettings.controls['fullName']?.dirty || formAccountSettings.controls['fullName']?.touched)" class="invalid-feedback">
                      Vollständiger Name ist erforderlich.
                    </div>
                  </div>
                  <div class="mb-3 col-md-6">
                    <label for="email" class="form-label">E-Mail</label>
                    <input
                      class="form-control"
                      type="email"
                      id="email"
                      name="email"
                      [(ngModel)]="userInfo.email"
                      placeholder="john.doe@beispiel.com"
                      required
                    />
                    <div *ngIf="formAccountSettings.controls['email']?.invalid && (formAccountSettings.controls['email']?.dirty || formAccountSettings.controls['email']?.touched)" class="invalid-feedback">
                      Gültige E-Mail-Adresse ist erforderlich.
                    </div>
                  </div>
                  <div class="mb-3 col-md-6">
                    <label for="job" class="form-label">Beruf</label>
                    <input
                      type="text"
                      class="form-control"
                      id="job"
                      name="job"
                      [(ngModel)]="userInfo.job"
                      placeholder="Ihr Beruf"
                    />
                  </div>
                  <div class="mb-3 col-md-6">
                    <label class="form-label" for="phoneNumber">Telefonnummer</label>
                    <div class="input-group input-group-merge">
                      <select id="phoneCode" class="select2 form-select" name="phoneCode" [(ngModel)]="userInfo.phoneCode">
                        <option value="">Auswählen</option>
                        <option value="+93">Afghanistan (+93)</option>
                        <option value="+355">Albanien (+355)</option>
                        <option value="+213">Algerien (+213)</option>
                        <option value="+376">Andorra (+376)</option>
                        <option value="+244">Angola (+244)</option>
                        <option value="+1">Anguilla (+1)</option>
                        <option value="+672">Antarktis (+672)</option>
                        <option value="+1">Antigua und Barbuda (+1)</option>
                        <option value="+54">Argentinien (+54)</option>
                        <option value="+374">Armenien (+374)</option>
                        <option value="+297">Aruba (+297)</option>
                        <option value="+61">Australien (+61)</option>
                        <option value="+43">Österreich (+43)</option>
                        <option value="+994">Aserbaidschan (+994)</option>
                        <option value="+1">Bahamas (+1)</option>
                        <option value="+973">Bahrain (+973)</option>
                        <option value="+880">Bangladesch (+880)</option>
                        <option value="+1">Barbados (+1)</option>
                        <option value="+375">Belarus (+375)</option>
                        <option value="+32">Belgien (+32)</option>
                        <option value="+501">Belize (+501)</option>
                        <option value="+229">Benin (+229)</option>
                        <option value="+1">Bermuda (+1)</option>
                        <option value="+975">Bhutan (+975)</option>
                        <option value="+591">Bolivien (+591)</option>
                        <option value="+387">Bosnien und Herzegowina (+387)</option>
                        <option value="+267">Botsuana (+267)</option>
                        <option value="+55">Brasilien (+55)</option>
                        <option value="+246">Britisches Territorium im Indischen Ozean (+246)</option>
                        <option value="+1">Britische Jungferninseln (+1)</option>
                        <option value="+673">Brunei (+673)</option>
                        <option value="+359">Bulgarien (+359)</option>
                        <option value="+226">Burkina Faso (+226)</option>
                        <option value="+257">Burundi (+257)</option>
                        <option value="+855">Kambodscha (+855)</option>
                        <option value="+237">Kamerun (+237)</option>
                        <option value="+1">Kanada (+1)</option>
                        <option value="+238">Kap Verde (+238)</option>
                        <option value="+1">Kaimaninseln (+1)</option>
                        <option value="+236">Zentralafrikanische Republik (+236)</option>
                        <option value="+235">Tschad (+235)</option>
                        <option value="+56">Chile (+56)</option>
                        <option value="+86">China (+86)</option>
                        <option value="+57">Kolumbien (+57)</option>
                        <option value="+269">Komoren (+269)</option>
                        <option value="+242">Kongo (+242)</option>
                        <option value="+243">Kongo, Demokratische Republik (+243)</option>
                        <option value="+682">Cookinseln (+682)</option>
                        <option value="+506">Costa Rica (+506)</option>
                        <option value="+225">Elfenbeinküste (+225)</option>
                        <option value="+385">Kroatien (+385)</option>
                        <option value="+53">Kuba (+53)</option>
                        <option value="+599">Curaçao (+599)</option>
                        <option value="+357">Zypern (+357)</option>
                        <option value="+420">Tschechische Republik (+420)</option>
                        <option value="+45">Dänemark (+45)</option>
                        <option value="+253">Dschibuti (+253)</option>
                        <option value="+1">Dominica (+1)</option>
                        <option value="+1">Dominikanische Republik (+1)</option>
                        <option value="+593">Ecuador (+593)</option>
                        <option value="+20">Ägypten (+20)</option>
                        <option value="+503">El Salvador (+503)</option>
                        <option value="+240">Äquatorialguinea (+240)</option>
                        <option value="+291">Eritrea (+291)</option>
                        <option value="+372">Estland (+372)</option>
                        <option value="+268">Eswatini (+268)</option>
                        <option value="+251">Äthiopien (+251)</option>
                        <option value="+500">Falklandinseln (+500)</option>
                        <option value="+298">Färöer (+298)</option>
                        <option value="+679">Fidschi (+679)</option>
                        <option value="+358">Finnland (+358)</option>
                        <option value="+33">Frankreich (+33)</option>
                        <option value="+594">Französisch-Guayana (+594)</option>
                        <option value="+689">Französisch-Polynesien (+689)</option>
                        <option value="+241">Gabun (+241)</option>
                        <option value="+220">Gambia (+220)</option>
                        <option value="+995">Georgien (+995)</option>
                        <option value="+49">Deutschland (+49)</option>
                        <option value="+233">Ghana (+233)</option>
                        <option value="+350">Gibraltar (+350)</option>
                        <option value="+30">Griechenland (+30)</option>
                        <option value="+299">Grönland (+299)</option>
                        <option value="+1">Grenada (+1)</option>
                        <option value="+590">Guadeloupe (+590)</option>
                        <option value="+1">Guam (+1)</option>
                        <option value="+502">Guatemala (+502)</option>
                        <option value="+44">Guernsey (+44)</option>
                        <option value="+224">Guinea (+224)</option>
                        <option value="+245">Guinea-Bissau (+245)</option>
                        <option value="+592">Guyana (+592)</option>
                        <option value="+509">Haiti (+509)</option>
                        <option value="+504">Honduras (+504)</option>
                        <option value="+852">Hongkong (+852)</option>
                        <option value="+36">Ungarn (+36)</option>
                        <option value="+354">Island (+354)</option>
                        <option value="+91">Indien (+91)</option>
                        <option value="+62">Indonesien (+62)</option>
                        <option value="+98">Iran (+98)</option>
                        <option value="+964">Irak (+964)</option>
                        <option value="+353">Irland (+353)</option>
                        <option value="+44">Isle of Man (+44)</option>
                        <option value="+972">Israel (+972)</option>
                        <option value="+39">Italien (+39)</option>
                        <option value="+1">Jamaika (+1)</option>
                        <option value="+81">Japan (+81)</option>
                        <option value="+44">Jersey (+44)</option>
                        <option value="+962">Jordanien (+962)</option>
                        <option value="+7">Kasachstan (+7)</option>
                        <option value="+254">Kenia (+254)</option>
                        <option value="+686">Kiribati (+686)</option>
                        <option value="+383">Kosovo (+383)</option>
                        <option value="+965">Kuwait (+965)</option>
                        <option value="+996">Kirgisistan (+996)</option>
                        <option value="+856">Laos (+856)</option>
                        <option value="+371">Lettland (+371)</option>
                        <option value="+961">Libanon (+961)</option>
                        <option value="+266">Lesotho (+266)</option>
                        <option value="+231">Liberia (+231)</option>
                        <option value="+218">Libyen (+218)</option>
                        <option value="+423">Liechtenstein (+423)</option>
                        <option value="+370">Litauen (+370)</option>
                        <option value="+352">Luxemburg (+352)</option>
                        <option value="+853">Macau (+853)</option>
                        <option value="+389">Nordmazedonien (+389)</option>
                        <option value="+261">Madagaskar (+261)</option>
                        <option value="+265">Malawi (+265)</option>
                        <option value="+60">Malaysia (+60)</option>
                        <option value="+960">Malediven (+960)</option>
                        <option value="+223">Mali (+223)</option>
                        <option value="+356">Malta (+356)</option>
                        <option value="+692">Marshallinseln (+692)</option>
                        <option value="+596">Martinique (+596)</option>
                        <option value="+222">Mauretanien (+222)</option>
                        <option value="+230">Mauritius (+230)</option>
                        <option value="+262">Mayotte (+262)</option>
                        <option value="+52">Mexiko (+52)</option>
                        <option value="+691">Mikronesien (+691)</option>
                        <option value="+373">Moldawien (+373)</option>
                        <option value="+377">Monaco (+377)</option>
                        <option value="+976">Mongolei (+976)</option>
                        <option value="+382">Montenegro (+382)</option>
                        <option value="+1">Montserrat (+1)</option>
                        <option value="+212">Marokko (+212)</option>
                        <option value="+258">Mosambik (+258)</option>
                        <option value="+95">Myanmar (+95)</option>
                        <option value="+264">Namibia (+264)</option>
                        <option value="+674">Nauru (+674)</option>
                        <option value="+977">Nepal (+977)</option>
                        <option value="+31">Niederlande (+31)</option>
                        <option value="+687">Neukaledonien (+687)</option>
                        <option value="+64">Neuseeland (+64)</option>
                        <option value="+505">Nicaragua (+505)</option>
                        <option value="+227">Niger (+227)</option>
                        <option value="+234">Nigeria (+234)</option>
                        <option value="+683">Niue (+683)</option>
                        <option value="+672">Norfolkinsel (+672)</option>
                        <option value="+850">Nordkorea (+850)</option>
                        <option value="+1">Nördliche Marianen (+1)</option>
                        <option value="+47">Norwegen (+47)</option>
                        <option value="+968">Oman (+968)</option>
                        <option value="+92">Pakistan (+92)</option>
                        <option value="+680">Palau (+680)</option>
                        <option value="+970">Palästina (+970)</option>
                        <option value="+507">Panama (+507)</option>
                        <option value="+675">Papua-Neuguinea (+675)</option>
                        <option value="+595">Paraguay (+595)</option>
                        <option value="+51">Peru (+51)</option>
                        <option value="+63">Philippinen (+63)</option>
                        <option value="+48">Polen (+48)</option>
                        <option value="+351">Portugal (+351)</option>
                        <option value="+1">Puerto Rico (+1)</option>
                        <option value="+974">Katar (+974)</option>
                        <option value="+262">Réunion (+262)</option>
                        <option value="+40">Rumänien (+40)</option>
                        <option value="+7">Russland (+7)</option>
                        <option value="+250">Ruanda (+250)</option>
                        <option value="+590">Saint Barthélemy (+590)</option>
                        <option value="+290">Saint Helena (+290)</option>
                        <option value="+1">St. Kitts und Nevis (+1)</option>
                        <option value="+1">St. Lucia (+1)</option>
                        <option value="+590">Saint Martin (+590)</option>
                        <option value="+508">Saint Pierre und Miquelon (+508)</option>
                        <option value="+1">St. Vincent und die Grenadinen (+1)</option>
                        <option value="+685">Samoa (+685)</option>
                        <option value="+378">San Marino (+378)</option>
                        <option value="+239">São Tomé und Príncipe (+239)</option>
                        <option value="+966">Saudi-Arabien (+966)</option>
                        <option value="+221">Senegal (+221)</option>
                        <option value="+381">Serbien (+381)</option>
                        <option value="+248">Seychellen (+248)</option>
                        <option value="+232">Sierra Leone (+232)</option>
                        <option value="+65">Singapur (+65)</option>
                        <option value="+1">Sint Maarten (+1)</option>
                        <option value="+421">Slowakei (+421)</option>
                        <option value="+386">Slowenien (+386)</option>
                        <option value="+677">Salomonen (+677)</option>
                        <option value="+252">Somalia (+252)</option>
                        <option value="+27">Südafrika (+27)</option>
                        <option value="+82">Südkorea (+82)</option>
                        <option value="+211">Südsudan (+211)</option>
                        <option value="+34">Spanien (+34)</option>
                        <option value="+94">Sri Lanka (+94)</option>
                        <option value="+249">Sudan (+249)</option>
                        <option value="+597">Suriname (+597)</option>
                        <option value="+47">Svalbard und Jan Mayen (+47)</option>
                        <option value="+46">Schweden (+46)</option>
                        <option value="+41">Schweiz (+41)</option>
                        <option value="+963">Syrien (+963)</option>
                        <option value="+886">Taiwan (+886)</option>
                        <option value="+992">Tadschikistan (+992)</option>
                        <option value="+255">Tansania (+255)</option>
                        <option value="+66">Thailand (+66)</option>
                        <option value="+670">Timor-Leste (+670)</option>
                        <option value="+228">Togo (+228)</option>
                        <option value="+690">Tokelau (+690)</option>
                        <option value="+676">Tonga (+676)</option>
                        <option value="+1">Trinidad und Tobago (+1)</option>
                        <option value="+216">Tunesien (+216)</option>
                        <option value="+90">Türkei (+90)</option>
                        <option value="+993">Turkmenistan (+993)</option>
                        <option value="+1">Turks- und Caicosinseln (+1)</option>
                        <option value="+688">Tuvalu (+688)</option>
                        <option value="+256">Uganda (+256)</option>
                        <option value="+380">Ukraine (+380)</option>
                        <option value="+971">Vereinigte Arabische Emirate (+971)</option>
                        <option value="+44">Vereinigtes Königreich (+44)</option>
                        <option value="+1">Vereinigte Staaten (+1)</option>
                        <option value="+1">Amerikanische Jungferninseln (+1)</option>
                        <option value="+598">Uruguay (+598)</option>
                        <option value="+998">Usbekistan (+998)</option>
                        <option value="+678">Vanuatu (+678)</option>
                        <option value="+39">Vatikanstadt (+39)</option>
                        <option value="+58">Venezuela (+58)</option>
                        <option value="+84">Vietnam (+84)</option>
                        <option value="+681">Wallis und Futuna (+681)</option>
                        <option value="+212">Westsahara (+212)</option>
                        <option value="+967">Jemen (+967)</option>
                        <option value="+260">Sambia (+260)</option>
                        <option value="+263">Simbabwe (+263)</option>
                      </select>
                      <input
                        type="text"
                        id="phoneNumber"
                        name="phoneNumber"
                        class="form-control"
                        placeholder="Telefonnummer"
                        [(ngModel)]="userInfo.phoneNumber"
                        pattern="[0-9]{7,15}"
                        #phoneNumber="ngModel"
                      />
                      <div *ngIf="phoneNumber.invalid && (phoneNumber.dirty || phoneNumber.touched)" class="invalid-feedback">
                        Bitte geben Sie eine gültige Telefonnummer ein (7-15 Ziffern).
                      </div>
                    </div>
                  </div>
                  <div class="mb-3 col-md-6">
                    <label for="address" class="form-label">Adresse</label>
                    <input type="text" class="form-control" id="address" name="address" placeholder="Adresse" [(ngModel)]="userInfo.address" />
                  </div>
                  <div class="mb-3 col-md-6">
                    <label class="form-label" for="country">Land</label>
                    <select id="country" class="select2 form-select" name="country" [(ngModel)]="userInfo.country">
                      <option value="">Auswählen</option>
                      <option value="Afghanistan">Afghanistan</option>
                      <option value="Albania">Albanien</option>
                      <option value="Algeria">Algerien</option>
                      <option value="Andorra">Andorra</option>
                      <option value="Angola">Angola</option>
                      <option value="Anguilla">Anguilla</option>
                      <option value="Antigua and Barbuda">Antigua und Barbuda</option>
                      <option value="Argentina">Argentinien</option>
                      <option value="Armenia">Armenien</option>
                      <option value="Aruba">Aruba</option>
                      <option value="Australia">Australien</option>
                      <option value="Austria">Österreich</option>
                      <option value="Azerbaijan">Aserbaidschan</option>
                      <option value="Bahamas">Bahamas</option>
                      <option value="Bahrain">Bahrain</option>
                      <option value="Bangladesh">Bangladesch</option>
                      <option value="Barbados">Barbados</option>
                      <option value="Belarus">Belarus</option>
                      <option value="Belgium">Belgien</option>
                      <option value="Belize">Belize</option>
                      <option value="Benin">Benin</option>
                      <option value="Bermuda">Bermuda</option>
                      <option value="Bhutan">Bhutan</option>
                      <option value="Bolivia">Bolivien</option>
                      <option value="Bosnia and Herzegovina">Bosnien und Herzegowina</option>
                      <option value="Botswana">Botsuana</option>
                      <option value="Brazil">Brasilien</option>
                      <option value="British Indian Ocean Territory">Britisches Territorium im Indischen Ozean</option>
                      <option value="British Virgin Islands">Britische Jungferninseln</option>
                      <option value="Brunei">Brunei</option>
                      <option value="Bulgaria">Bulgarien</option>
                      <option value="Burkina Faso">Burkina Faso</option>
                      <option value="Burundi">Burundi</option>
                      <option value="Cambodia">Kambodscha</option>
                      <option value="Cameroon">Kamerun</option>
                      <option value="Canada">Kanada</option>
                      <option value="Cape Verde">Kap Verde</option>
                      <option value="Cayman Islands">Kaimaninseln</option>
                      <option value="Central African Republic">Zentralafrikanische Republik</option>
                      <option value="Chad">Tschad</option>
                      <option value="Chile">Chile</option>
                      <option value="China">China</option>
                      <option value="Colombia">Kolumbien</option>
                      <option value="Comoros">Komoren</option>
                      <option value="Congo">Kongo</option>
                      <option value="Congo, Democratic Republic of the">Kongo, Demokratische Republik</option>
                      <option value="Cook Islands">Cookinseln</option>
                      <option value="Costa Rica">Costa Rica</option>
                      <option value="Côte d'Ivoire">Elfenbeinküste</option>
                      <option value="Croatia">Kroatien</option>
                      <option value="Cuba">Kuba</option>
                      <option value="Curaçao">Curaçao</option>
                      <option value="Cyprus">Zypern</option>
                      <option value="Czech Republic">Tschechische Republik</option>
                      <option value="Denmark">Dänemark</option>
                      <option value="Djibouti">Dschibuti</option>
                      <option value="Dominica">Dominica</option>
                      <option value="Dominican Republic">Dominikanische Republik</option>
                      <option value="Ecuador">Ecuador</option>
                      <option value="Egypt">Ägypten</option>
                      <option value="El Salvador">El Salvador</option>
                      <option value="Equatorial Guinea">Äquatorialguinea</option>
                      <option value="Eritrea">Eritrea</option>
                      <option value="Estonia">Estland</option>
                      <option value="Eswatini">Eswatini</option>
                      <option value="Ethiopia">Äthiopien</option>
                      <option value="Falkland Islands">Falklandinseln</option>
                      <option value="Faroe Islands">Färöer</option>
                      <option value="Fiji">Fidschi</option>
                      <option value="Finland">Finnland</option>
                      <option value="France">Frankreich</option>
                      <option value="French Guiana">Französisch-Guayana</option>
                      <option value="French Polynesia">Französisch-Polynesien</option>
                      <option value="Gabon">Gabun</option>
                      <option value="Gambia">Gambia</option>
                      <option value="Georgia">Georgien</option>
                      <option value="Germany">Deutschland</option>
                      <option value="Ghana">Ghana</option>
                      <option value="Gibraltar">Gibraltar</option>
                      <option value="Greece">Griechenland</option>
                      <option value="Greenland">Grönland</option>
                      <option value="Grenada">Grenada</option>
                      <option value="Guadeloupe">Guadeloupe</option>
                      <option value="Guam">Guam</option>
                      <option value="Guatemala">Guatemala</option>
                      <option value="Guernsey">Guernsey</option>
                      <option value="Guinea">Guinea</option>
                      <option value="Guinea-Bissau">Guinea-Bissau</option>
                      <option value="Guyana">Guyana</option>
                      <option value="Haiti">Haiti</option>
                      <option value="Honduras">Honduras</option>
                      <option value="Hong Kong">Hongkong</option>
                      <option value="Hungary">Ungarn</option>
                      <option value="Iceland">Island</option>
                      <option value="India">Indien</option>
                      <option value="Indonesia">Indonesien</option>
                      <option value="Iran">Iran</option>
                      <option value="Iraq">Irak</option>
                      <option value="Ireland">Irland</option>
                      <option value="Isle of Man">Isle of Man</option>
                      <option value="Israel">Israel</option>
                      <option value="Italy">Italien</option>
                      <option value="Jamaica">Jamaika</option>
                      <option value="Japan">Japan</option>
                      <option value="Jersey">Jersey</option>
                      <option value="Jordan">Jordanien</option>
                      <option value="Kazakhstan">Kasachstan</option>
                      <option value="Kenya">Kenia</option>
                      <option value="Kiribati">Kiribati</option>
                      <option value="Kosovo">Kosovo</option>
                      <option value="Kuwait">Kuwait</option>
                      <option value="Kyrgyzstan">Kirgisistan</option>
                      <option value="Laos">Laos</option>
                      <option value="Latvia">Lettland</option>
                      <option value="Lebanon">Libanon</option>
                      <option value="Lesotho">Lesotho</option>
                      <option value="Liberia">Liberia</option>
                      <option value="Libya">Libyen</option>
                      <option value="Liechtenstein">Liechtenstein</option>
                      <option value="Lithuania">Litauen</option>
                      <option value="Luxembourg">Luxemburg</option>
                      <option value="Macau">Macau</option>
                      <option value="North Macedonia">Nordmazedonien</option>
                      <option value="Madagascar">Madagaskar</option>
                      <option value="Malawi">Malawi</option>
                      <option value="Malaysia">Malaysia</option>
                      <option value="Maldives">Malediven</option>
                      <option value="Mali">Mali</option>
                      <option value="Malta">Malta</option>
                      <option value="Marshall Islands">Marshallinseln</option>
                      <option value="Martinique">Martinique</option>
                      <option value="Mauritania">Mauretanien</option>
                      <option value="Mauritius">Mauritius</option>
                      <option value="Mayotte">Mayotte</option>
                      <option value="Mexico">Mexiko</option>
                      <option value="Micronesia">Mikronesien</option>
                      <option value="Moldova">Moldawien</option>
                      <option value="Monaco">Monaco</option>
                      <option value="Mongolia">Mongolei</option>
                      <option value="Montenegro">Montenegro</option>
                      <option value="Montserrat">Montserrat</option>
                      <option value="Morocco">Marokko</option>
                      <option value="Mozambique">Mosambik</option>
                      <option value="Myanmar">Myanmar</option>
                      <option value="Namibia">Namibia</option>
                      <option value="Nauru">Nauru</option>
                      <option value="Nepal">Nepal</option>
                      <option value="Netherlands">Niederlande</option>
                      <option value="New Caledonia">Neukaledonien</option>
                      <option value="New Zealand">Neuseeland</option>
                      <option value="Nicaragua">Nicaragua</option>
                      <option value="Niger">Niger</option>
                      <option value="Nigeria">Nigeria</option>
                      <option value="Niue">Niue</option>
                      <option value="Norfolk Island">Norfolkinsel</option>
                      <option value="North Korea">Nordkorea</option>
                      <option value="Northern Mariana Islands">Nördliche Marianen</option>
                      <option value="Norway">Norwegen</option>
                      <option value="Oman">Oman</option>
                      <option value="Pakistan">Pakistan</option>
                      <option value="Palau">Palau</option>
                      <option value="Palestine">Palästina</option>
                      <option value="Panama">Panama</option>
                      <option value="Papua New Guinea">Papua-Neuguinea</option>
                      <option value="Paraguay">Paraguay</option>
                      <option value="Peru">Peru</option>
                      <option value="Philippines">Philippinen</option>
                      <option value="Poland">Polen</option>
                      <option value="Portugal">Portugal</option>
                      <option value="Puerto Rico">Puerto Rico</option>
                      <option value="Qatar">Katar</option>
                      <option value="Réunion">Réunion</option>
                      <option value="Romania">Rumänien</option>
                      <option value="Russia">Russland</option>
                      <option value="Rwanda">Ruanda</option>
                      <option value="Saint Barthélemy">Saint Barthélemy</option>
                      <option value="Saint Helena">Saint Helena</option>
                      <option value="Saint Kitts and Nevis">St. Kitts und Nevis</option>
                      <option value="Saint Lucia">St. Lucia</option>
                      <option value="Saint Martin">Saint Martin</option>
                      <option value="Saint Pierre and Miquelon">Saint Pierre und Miquelon</option>
                      <option value="Saint Vincent and the Grenadines">St. Vincent und die Grenadinen</option>
                      <option value="Samoa">Samoa</option>
                      <option value="San Marino">San Marino</option>
                      <option value="São Tomé and Príncipe">São Tomé und Príncipe</option>
                      <option value="Saudi Arabia">Saudi-Arabien</option>
                      <option value="Senegal">Senegal</option>
                      <option value="Serbia">Serbien</option>
                      <option value="Seychelles">Seychellen</option>
                      <option value="Sierra Leone">Sierra Leone</option>
                      <option value="Singapore">Singapur</option>
                      <option value="Sint Maarten">Sint Maarten</option>
                      <option value="Slovakia">Slowakei</option>
                      <option value="Slovenia">Slowenien</option>
                      <option value="Solomon Islands">Salomonen</option>
                      <option value="Somalia">Somalia</option>
                      <option value="South Africa">Südafrika</option>
                      <option value="South Korea">Südkorea</option>
                      <option value="South Sudan">Südsudan</option>
                      <option value="Spain">Spanien</option>
                      <option value="Sri Lanka">Sri Lanka</option>
                      <option value="Sudan">Sudan</option>
                      <option value="Suriname">Suriname</option>
                      <option value="Svalbard and Jan Mayen">Svalbard und Jan Mayen</option>
                      <option value="Sweden">Schweden</option>
                      <option value="Switzerland">Schweiz</option>
                      <option value="Syria">Syrien</option>
                      <option value="Taiwan">Taiwan</option>
                      <option value="Tajikistan">Tadschikistan</option>
                      <option value="Tanzania">Tansania</option>
                      <option value="Thailand">Thailand</option>
                      <option value="Timor-Leste">Timor-Leste</option>
                      <option value="Togo">Togo</option>
                      <option value="Tokelau">Tokelau</option>
                      <option value="Tonga">Tonga</option>
                      <option value="Trinidad and Tobago">Trinidad und Tobago</option>
                      <option value="Tunisia">Tunesien</option>
                      <option value="Turkey">Türkei</option>
                      <option value="Turkmenistan">Turkmenistan</option>
                      <option value="Turks and Caicos Islands">Turks- und Caicosinseln</option>
                      <option value="Tuvalu">Tuvalu</option>
                      <option value="Uganda">Uganda</option>
                      <option value="Ukraine">Ukraine</option>
                      <option value="United Arab Emirates">Vereinigte Arabische Emirate</option>
                      <option value="United Kingdom">Vereinigtes Königreich</option>
                      <option value="United States">Vereinigte Staaten</option>
                      <option value="U.S. Virgin Islands">Amerikanische Jungferninseln</option>
                      <option value="Uruguay">Uruguay</option>
                      <option value="Uzbekistan">Usbekistan</option>
                      <option value="Vanuatu">Vanuatu</option>
                      <option value="Vatican City">Vatikanstadt</option>
                      <option value="Venezuela">Venezuela</option>
                      <option value="Vietnam">Vietnam</option>
                      <option value="Wallis and Futuna">Wallis und Futuna</option>
                      <option value="Western Sahara">Westsahara</option>
                      <option value="Yemen">Jemen</option>
                      <option value="Zambia">Sambia</option>
                      <option value="Zimbabwe">Simbabwe</option>
                    </select>
                  </div>
                </div>
                <div class="mt-2">
                  <button type="submit" class="btn btn-primary me-2">Änderungen speichern</button>
                  <button type="reset" class="btn btn-outline-secondary">Abbrechen</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- Notifications Tab -->
        <div
          class="tab-pane fade"
          [class.show]="activeTab === 'notifications'"
          [class.active]="activeTab === 'notifications'"
          id="notifications"
          role="tabpanel"
          aria-labelledby="notifications-tab"
        >
          <app-notifications></app-notifications>
        </div>

        <!-- My Applications Tab -->
        <div
          class="tab-pane fade"
          [class.show]="activeTab === 'applications'"
          [class.active]="activeTab === 'applications'"
          id="applications"
          role="tabpanel"
          aria-labelledby="applications-tab"
        >
          <div class="card mb-4">
            <h5 class="card-header">Meine Bewerbungen</h5>
            <div class="card-body">
              <p>Hier können Sie Ihre Bewerbungen einsehen und verwalten.</p>
              <div *ngIf="applications.length === 0" class="text-center text-muted mb-3">
                Keine Bewerbungen gefunden.
              </div>
              <div *ngIf="applications.length > 0" class="table-responsive">
                <table class="table table-hover table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th>Stellenbezeichnung</th>
                      <th>Kategorie</th>
                      <th>Status</th>
                      <th>Bewerbungsdatum</th>
                      <th>Lebenslauf</th>
                      <th>Anschreiben</th>
                      <th>Aktionen</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let app of applications">
                      <td>{{ app.job.title }}</td>
                      <td>{{ app.job.category }}</td>
                      <td>
                        <span
                          class="badge"
                          [ngClass]="{
                            'bg-label-primary': app.status === 'pending',
                            'bg-label-info': app.status === 'reviewed',
                            'bg-label-success': app.status === 'accepted',
                            'bg-label-danger': app.status === 'rejected'
                          }"
                        >
                          {{ app.status | titlecase }}
                        </span>
                      </td>
                      <td>{{ app.applicationDate?.toDate() | date: 'medium' }}</td>
                      <td>
                        <a [href]="app.cvUrl" target="_blank" class="btn btn-sm btn-outline-primary">
                          <i class="fas fa-file-alt me-1"></i> Lebenslauf ansehen
                        </a>
                      </td>
                      <td class="text-truncate" style="max-width: 200px;" [title]="app.coverLetter">
                        {{ app.coverLetter }}
                      </td>
                      <td>
                        <button
                          class="btn btn-sm btn-outline-info me-1"
                          [routerLink]="['/job-details', app.job.id]"
                          title="Stellendetails ansehen"
                        >
                          <i class="fas fa-eye"></i>   
                        </button>
                        <button
                          [disabled]="app.status=='accepted' || app.status=='rejected'"
                          class="btn btn-sm btn-outline-warning me-1"
                          data-bs-toggle="modal" data-bs-target="#applicationModal"
                          (click)="openUpdateModal(app)"
                          title="Bewerbung aktualisieren"
                        >
                          <i class="fas fa-edit"></i>
                        </button>
                        <button
                          class="btn btn-sm btn-outline-danger"
                          (click)="confirmDelete(app.id)"
                          title="Bewerbung löschen"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content-backdrop fade"></div>
</div>

<div class="modal fade" id="applicationModal" tabindex="-1" aria-labelledby="applicationModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Bewerbung aktualisieren</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form #updateForm="ngForm" (ngSubmit)="onUpdateApplication(updateForm)">
          <div class="mb-3">
            <label for="coverLetter" class="form-label">Anschreiben</label>
            <textarea
              class="form-control"
              id="coverLetter"
              name="coverLetter"
              [(ngModel)]="selectedApplication.coverLetter"
              rows="5"
              required
            ></textarea>
            <div *ngIf="updateForm.controls['coverLetter']?.invalid && (updateForm.controls['coverLetter']?.dirty || updateForm.controls['coverLetter']?.touched)" class="invalid-feedback">
              Anschreiben ist erforderlich.
            </div>
          </div>
          <div class="mb-3">
            <label for="cvFile" class="form-label">Neuen Lebenslauf hochladen (PDF)</label>
            <input
              type="file"
              class="form-control"
              id="cvFile"
              name="cvFile"
              accept="application/pdf"
              (change)="onCvSelected($event)"
            />
            <small class="text-muted">Erlaubt sind PDF-Dateien. Maximale Größe: 2 MB.</small>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Abbrechen</button>
            <button type="submit" class="btn btn-primary" [disabled]="updateForm.invalid" data-bs-dismiss="modal">Änderungen speichern</button>
          </div>
        </form>
      </div>
    </div>
  </div> 
</div>